import React, { useState } from "react";
import { Box, Typography, Checkbox, FormControlLabel, Grid } from "@mui/material";
import { IAssignment,ISubmissiontype } from "../../Assignment/index"


interface IFeedback {
    assignData: IAssignment;
    handleCheckBoxChange: (e: React.ChangeEvent<HTMLInputElement>) => void;

}
const Feedback: React.FC<IFeedback> = ({
    assignData,
    handleCheckBoxChange,
}:IFeedback) => {



    return (
        <Box sx={{ p: 2, background: "#F8FAFD", borderRadius: "8px",textAlign:"start" }}>
            <Typography sx={{ fontSize: "14px", fontWeight: 500, mb: 1 }}>
                Feedback Types
            </Typography>
            <Grid container spacing={2} alignItems="center">
                <Grid item>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={assignData.assignfeedback_comments_enabled?true:false}
                                onChange={handleCheckBoxChange}
                                name="assignfeedback_comments_enabled"
                                color="primary"
                                disabled={true}
                            />
                        }
                        label="Feedback Comments"
                    />
                </Grid>
                <Grid item>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={assignData.assignfeedback_file_enabled?true:false}
                                onChange={handleCheckBoxChange}
                                name="assignfeedback_file_enabled"
                                color="primary"
                                disabled={true}

                            />
                        }
                        label="Feedback Files"
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

export default Feedback;
